import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.ICouponState;
}

const getFeatureState = (state: IAppState) => state[Reducer.statePropName];

export const isLoaded = (state: IAppState) => !getFeatureState(state).loading;

export const getCurrentCoupon = (state: IAppState) => getFeatureState(state).coupon;

export const isDay0Coupon = (state: IAppState) => getFeatureState(state).isDay0;
